// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export { StoredProcedure } from "./StoredProcedure.js";
export { StoredProcedures } from "./StoredProcedures.js";
export type { StoredProcedureDefinition } from "./StoredProcedureDefinition.js";
export { StoredProcedureResponse } from "./StoredProcedureResponse.js";
